import { useAuth } from 'lib/auth';
import { axios } from 'lib/axios';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

export const updateAddress = ({ data }) => {
  return axios.patch(`/users/profile/address`, data);
};

export const useUpdateAddress = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  const { refetchUser } = useAuth();
  return useMutation({
    onSuccess: (data) => {
      addNotification({
        type: 'success',
        title: 'Address Updated',
      });
      refetchUser();
    },
    ...config,
    mutationFn: updateAddress,
  });
};
